<template>
  <section class="-wrapper-tile feature- -summary-grid -border-radius-1">
    <div class="-wrapper-column -width-100">
      <div class="-header">
        <p class="-h2 -font-weight-medium">{{ $t('pages_sales_info_bill_info.title') }}</p>
      </div>
      <div class="-wrapper -px-5 -pt-5">
        <g-dropdown
          id="sales-info-bill-info-select-month"
          :value=selectMonth
          variant="borderless"
          dropdownType="default"
          buttonSize="large"
          @change="onSelected"
        >
          <g-dropdown-item-wrap>
            <g-dropdown-item :key="val" :text="val" :value="val" v-for="val in dateList" />
          </g-dropdown-item-wrap>
        </g-dropdown>
        <p id="sales-info-bill-info-receve-status" v-bind:class="receiveStatusName == '완납' ? '-tag green- -ml-2' : receiveStatusName == '납부전' ? '-tag red- -ml-2' : '-tag yellow- -ml-2'">
          {{receiveStatusName}}
        </p>
      </div>
      <div class="-wrapper -px-5">
        <time class="-description">{{ selectMonth }}/01 ~ {{ selectMonth }}/ {{ new Date(selectMonth.substring(0, 4), selectMonth.substring(5, 7), 0).getDate()    }}</time>
      </div>

      <div class="-wrapper-column -mt-2 -px-5">
        <p class="--wrapper start-">
          <span class="-color-gray-1 -font-size-12">{{ $t('pages_sales_info_bill_info.total_amount')}}</span>
        </p>
        <div class="--wrapper-end">
          <p id="sales-info-bill-info-total-trad-amount" class="-number l- -ml-2">￦{{ invoices.totalTradeAmountByKrw}}</p>
        </div>
      </div>

      <div class="-wrapper-column -mt-2 -px-5 -pb-5">
        <p class="--wrapper start-">
          <span class="-color-gray-1 -font-size-12">{{ $t('pages_sales_info_bill_info.total_unpaid_amount') }}</span>
        </p>
        <div class="--wrapper-end">
          <p id="sales-info-bill-info-before-total-trad-amount" class="-number l- -ml-2">￦{{ invoices.remainAmountByKrw }}</p>
        </div>
      </div>

      <div class="-wrapper-column -bg-lightgray-3 -pt-2 -px-5 -pb-5">
        <div class="-wrapper between- -border-bottom -pb-2">
          <p class="-h4 -font-weight-medium">{{ $t('pages_sales_info_bill_info.manager_title')}}</p>
        </div>
        <div class="-wrapper between- -mt-2">
          <p class="-h5 --wrapper v-center-">{{ $t('pages_sales_info_bill_info.manager')}}</p>
          <p id="sales-info-bill-info-manage-name" class="-number xs- -color-gray-1">{{ manager != null ? manager.employeeName : ''}}</p>
        </div>
        <div class="-wrapper between- -mt-1">
          <p class="-h5 --wrapper v-center-">{{ $t('pages_sales_info_bill_info.manager_tel')}}</p>
          <p id="sales-info-bill-info-manage-tel" class="-number xs- -color-gray-1">{{  manager != null ? manager.employeeTel : '' }}</p>
        </div>
        <div class="-wrapper between- -mt-1" v-if="manager != null">
          <p class="-h5 --wrapper v-center-">{{ $t('pages_sales_info_bill_info.manager_email')}}</p>
          <a id="sales-info-bill-info-manage-mail"  :href="`mailto:${manager.employeeEmail}`" class="-color-blue-1 -font-size-12 -font-weight-medium link-">{{ manager != null ? manager.employeeEmail : '' }}</a>
        </div>
      </div>

      <div class="-wrapper -px-5 -pt-5">
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { CURRENCY_SYMBOL } from "@/constants/constants";
import moment from "moment";

export default {
  data () {
    return {
      won : CURRENCY_SYMBOL.KRW,
      receiveStatusName : '',
      selectMonth : '',
      invoiceParam : {},
    }
  },
  computed:{
    ...mapGetters('bills', ['invoices', 'manager', 'dateList', 'invoice']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    ...mapActions('bills', ['getCustomerBillUser', 'getInvoices', 'getInvoicesGetChartData']),
    onSelected (select) {
      this.selectMonth = select
      this.invoiceParam.endMonth = moment(select.replace('-','')).format("YYYYMM")
      this.invoiceParam.startMonth = moment(select.replace('-','')).add(this.invoice.amount, "M").format("YYYYMM")
      this.getInvoicesGetChartData(this.invoiceParam)
      this.invoiceParam.currentMonth = this.invoiceParam.endMonth
      this.getInvoices(this.invoiceParam)
    },
    getMoment(amount){
      return moment(new Date()).add(amount, "M").format("YYYYMM")
    }
  },

  mounted () {
    this.invoiceParam = this.$route.query
    if(this.userInfo.auth === "AM"){
      this.receiveStatusName = ''
      this.selectMonth = this.dateList[0]
    }else{
      this.receiveStatusName = this.invoiceParam.receiveStatusName
    }
    this.selectMonth = this.invoiceParam.currentMonth.substring(0, 4) + '-' + this.invoiceParam.currentMonth.substring(4, 6)
    this.getCustomerBillUser({ customerDeptCode : this.invoiceParam.deptCode, customerCode : this.invoiceParam.customerCode})
  },
  watch: {
    invoices() {
      if(this.invoices.invoices.length !== 0){
        let nameList = this.invoices.invoices.filter(item => item.receiveStatusName !== this.$t('pages_sales_info_invoice_chart.cancel'))
        let tempName = nameList[0].receiveStatusName
        if(nameList.filter(item => item.receiveStatusName !== tempName).length === 0){
          this.receiveStatusName = tempName
        }else{
          this.receiveStatusName = '부분납'
        }
      }else{
        this.selectMonth = this.dateList[0]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sales/components/SalesInfoBillInfo.vue